module.exports = __webpack_public_path__ + "img/3_buku harapan.7138ca05.jpg";